import React, { useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import { logout } from "../../../adapters/apis/auth/auth";
import AuthContext from "../../../contexts/AuthProvider";
import MainContent from "../../../layouts/maincontent/MainContent";
import UseAuth from "../../../hooks/UseAuth";
import styles from "./UserSettings.module.css";
import styleProfile from "./Profile.module.css";
import manMask from "../../../assets/img/manMask.png";
import technicalSupport from "../../../assets/img/technical-support.png";
import policy from "../../../assets/img/policy.png";
import emptyWallet from "../../../assets/img/empty-wallet.png";
import logoutImg from "../../../assets/img/logout.png";
import profileEdit from "../../../assets/img/user-edit.png";

function UserSettings() {
  const navigate = useNavigate();
  const { setAuth } = useContext(AuthContext);
  const { auth } = UseAuth();
  const [username, setUsername] = useState(auth.full_name);

  const [showBackModal, setShowBackModal] = useState(false);
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await logout();
      setAuth({});
      Cookies.remove("auth-token");
      Cookies.remove("user-name");
      Cookies.remove("refresh-token");
      // Cookies.remove("phone_verified");
      // Cookies.remove("ocr_verified");
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      Cookies.remove("auth-token");
      Cookies.remove("user-name");
      Cookies.remove("refresh-token");
      // Cookies.remove("phone_verified");
      // Cookies.remove("ocr_verified");
      window.location.href = "/login";
    }
  };

  return (
    <MainContent>
      <section
        className={`${styleProfile["section-content"]} ${styles.section}`}
      >
        <div className={`${styles.container} container mb-5`}>
          <div className={styles.headerRow}>
            <button
              className={`${styles["btn-arrow"]} ms-3`}
              onClick={() => {
                navigate(`/`);
              }}
            >
              <i className="fa-solid fa-arrow-right"></i>
            </button>

            <h3 className={styles.title}>إدارة المستخدم</h3>
          </div>

          <div className={styles.cardsWrapper}>
            <div className={styles.card}>
              <div className={styles.userHeader}>
                <img src={manMask} alt="user-icon" width="100" height="100" />
                <h4 className={styles.userName}>{username}</h4>
              </div>

              {/*<Link to="/set-password" className={styles.cardItem}>
                <img
                  src={profileEdit}
                  alt="profile-edit-icon"
                  width="40"
                  height="40"
                />
                <span className={styles.itemText}>تعيين كلمة المرور</span>
               </Link>*/}

              <Link to="/profile" className={styles.cardItem}>
                <img
                  src={profileEdit}
                  alt="profile-edit-icon"
                  width="40"
                  height="40"
                />
                <span className={styles.itemText}>إدارة حساب المستخدم</span>
              </Link>

              {/*
             <Link to="/user-transactions" className={styles.cardItem}>
                <img
                  src={emptyWallet}
                  alt="empty-wallet-icon"
                  width="40"
                  height="40"
                />
                <span className={styles.itemText}>حساب تسويات المستخدم</span>
              </Link>
              */}

              <div
                className={`${styles.cardItem} ${styles.logoutItem}`}
                onClick={handleLogout}
                role="button"
              >
                <img src={logoutImg} alt="logout-icon" width="40" height="40" />
                <span className={styles.itemText}>تسجيل الخروج</span>
              </div>
            </div>

            <div className={styles.card}>
              <Link to="/support" className={styles.cardItem}>
                <img
                  src={technicalSupport}
                  alt="technical-support-icon"
                  width="40"
                  height="40"
                />
                <span className={styles.itemText}>الدعم الفني</span>
              </Link>
              <Link to="/terms-and-condition" className={styles.cardItem}>
                <img src={policy} alt="policy-icon" width="40" height="40" />
                <span className={styles.itemText}>
                  الشروط والأحكام والخصوصية
                </span>
              </Link>
              <Link to="/help-and-instructions" className={styles.cardItem}>
                <img src={policy} alt="policy-icon" width="40" height="40" />
                <span className={styles.itemText}>
                  مركز المساعدة و التعليمات
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </MainContent>
  );
}

export default UserSettings;
